import script from "./ProductTree.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductTree.vue?vue&type=script&setup=true&lang=js"

import "./ProductTree.vue?vue&type=style&index=0&id=d39e0778&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d39e0778"]])

export default __exports__